import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Section = styled.section`
  padding: 3.5rem 1.5rem 5rem;
  background: ${props => props.theme.colors.surface};

  @media (max-width: 700px) {
    padding: 3rem 1rem;
  }
`;

const Inner = styled.div`
  width: min(1180px, 100%);
  margin: 0 auto;
`;

const VideoFrame = styled(motion.figure)`
  overflow: hidden;
  border: 1px solid #27323d;
  border-radius: 1.5rem;
  background: #0f151c;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.14);
`;

const FrameBar = styled.div`
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.85rem;
  border-bottom: 1px solid #2d3945;
  background: #17202a;
  color: #aeb8c2;
  font-family: ${props => props.theme.fonts.mono};
  font-size: 0.68rem;

  .dots {
    display: flex;
    gap: 0.38rem;
  }

  i {
    width: 8px;
    height: 8px;
    display: block;
    border-radius: 50%;
    background: #64717e;
  }

  i:first-child { background: #ba5b55; }
  i:nth-child(2) { background: #c69649; }
  i:nth-child(3) { background: #4d8b6f; }
`;

const Video = styled.video`
  width: 100%;
  height: auto;
  display: block;
  background: #000;
`;

export const VideoShowcase: React.FC = () => {
  const [ref, inView] = useInView({ threshold: 0.12, triggerOnce: true });

  return (
    <Section id="video-showcase" ref={ref}>
      <Inner>
      <VideoFrame initial={{ opacity: 0, y: 18 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ delay: 0.12 }}>
        <FrameBar>
          <span className="dots"><i /><i /><i /></span>
          <span>advcli · demo</span>
          <span>REC</span>
        </FrameBar>
        <Video autoPlay controls muted loop playsInline preload="metadata">
          <source src={`${process.env.PUBLIC_URL}/gemini.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </Video>
      </VideoFrame>
      </Inner>
    </Section>
  );
};
